import { RegMenReportsService } from "~/entity/RegMenReports/api/service";

import { useRegMenReportFileMutation } from "./useRegMenReportMutation";

export const useGetRegMenConsolidateReportFile = (onSuccess?: () => void) => {
  const { isLoading, isError, mutate } = useRegMenReportFileMutation(
    RegMenReportsService.POST.getRegMenByDealerConsolidateFile,
    onSuccess,
  );

  return {
    isLoading,
    isError,
    getRegMenConsolidateReportFile: mutate,
  };
};
